import { createSlice } from '@reduxjs/toolkit';
import { connectDomainThunk, disconnectDomainThunk, fetchDomainDNSThunk, fetchDomainsThunk, updateDomainThunk } from '../thunks/domain';
import { DomainObject, DomainState } from '../../params/redux/domain';

// Initial state with default values for authentication and user info
const initialState: DomainState = {
    domain: null,
    connectDomain: {
        domain_name: '',
        domain_seller: '',
        domain_host: '',
        site_title: '',
        website_description: '',
        favicon_image: '',
        social_image: '',
        domain_records: ''
    },
    flags: {
        isConnecting: false,
        selectedIndex: 0
    },
    loaders: {
        isLoading: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
        isSearching: false,
        isInserting: false
    }
};

// Slice for app-related states and actions
const domainSlice = createSlice({
    // Slice name
    name: 'domain',
    // inital state for the slice
    initialState,
    reducers: {
        settingIsConnectingFlagDomain: (state, action) => {
            state.flags.isConnecting = action.payload;
        },
        settingIndexForConnectingDomain: (state, action) => {
            state.flags.selectedIndex = action.payload;
        },
        settingConnectingDomain: (state, action) => {
            state.connectDomain = action.payload;
        },
        // Resets loading states related to app actions
        resettingDomainLoader: (state) => {
            state.loaders = initialState.loaders;
        },
        // Resets all app data to the initial state
        resettingDomainData: () => initialState
    },
    extraReducers: (builder) => {
        // Handle async actions for login
        builder
            .addCase(connectDomainThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isCreating = true;
            })
            .addCase(connectDomainThunk.fulfilled, () => {
                //
            })
            .addCase(connectDomainThunk.rejected, () => {
                //
            });
        builder
            .addCase(fetchDomainsThunk.pending, (state) => {
                state.loaders.isLoading = true;
                state.domain = null;
            })
            .addCase(fetchDomainsThunk.fulfilled, (state, action) => {
                state.domain = action.payload as DomainObject;
            })
            .addCase(fetchDomainsThunk.rejected, (state) => {
                state.domain = null;
            });
        builder
            .addCase(fetchDomainDNSThunk.pending, (state) => {
                state.loaders.isLoading = true;
                state.domain = null;
            })
            .addCase(fetchDomainDNSThunk.fulfilled, (state, action) => {
                state.domain = action.payload as DomainObject;
            })
            .addCase(fetchDomainDNSThunk.rejected, (state) => {
                state.domain = null;
            });
        builder
            .addCase(updateDomainThunk.pending, (state) => {
                state.loaders.isUpdating = true;
            })
            .addCase(updateDomainThunk.fulfilled, () => {
                //
            })
            .addCase(updateDomainThunk.rejected, () => {
                //
            });
        builder
            .addCase(disconnectDomainThunk.pending, (state) => {
                state.loaders.isDeleting = true;
            })
            .addCase(disconnectDomainThunk.fulfilled, () => {
                //
            })
            .addCase(disconnectDomainThunk.rejected, () => {
                //
            });
    }
});

// Exporting actions for updating app state
export const {
    settingIndexForConnectingDomain,
    settingIsConnectingFlagDomain,
    settingConnectingDomain,
    resettingDomainLoader,
    resettingDomainData
} = domainSlice.actions;

// Exporting the reducer to be used in the store
export default domainSlice.reducer;
